import moment from 'moment'

import { isNumber, isString } from 'lodash'

/**
 * Check if given string is a valid ISO date.
 *
 * @param {string|number} value
 * @returns {boolean}
 */
export function isValidISO8601(value) {
    // @TODO Refactor this
    const validFormats = [
        // Default date format
        moment.ISO_8601,
        // Unix ms timestamp
        'x'
    ]
    return !!(
        !!value &&
        (isString(value) || isNumber(value)) &&
        moment(value, validFormats, true).isValid() &&
        !isNaN(Number(new Date(value)))
    )
}
